export default __webpack_public_path__ + "static/bets-9e03c002acdc5f9820c8bcb32a6abb95.svg";